import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=70211197&scoped=true"
import script from "./ClientDashboard.vue?vue&type=script&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClientDashboard.vue?vue&type=style&index=0&id=70211197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70211197",
  null
  
)

export default component.exports